// File: /pages/About/Events_Hub.js
/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import Discuss from 'parts/Discuss';
import Button from 'elements/Button';

const events = [
  { id: 1, date: '2025-03-12', title: 'Cloud Workshop: Best Practices' },
  { id: 2, date: '2025-04-20', title: 'Cybersecurity Roundtable' },
];

export default function EventsHub() {
  return (
    <>

      <section className="hero py-12">
        <div className="container mx-auto px-6 text-center">
          <h1 className="text-5xl font-bold text-theme-blue mb-4">Events Hub</h1>
          <p className="text-gray-600 max-w-3xl mx-auto">Upcoming workshops, webinars and community events — join us to learn and network.</p>
        </div>
      </section>

      <section className="py-16">
        <div className="container mx-auto px-6 grid gap-6">
          {events.map((e) => (
            <div key={e.id} className="p-6 bg-white rounded-2xl shadow-md flex items-center justify-between">
              <div>
                <h3 className="text-xl font-semibold">{e.title}</h3>
                <p className="text-sm text-gray-600">{e.date}</p>
              </div>
              <div>
                <Button href={`/events/${e.id}`} type="link" className="px-4 py-2 bg-theme-purple text-white rounded-full">Learn More</Button>
              </div>
            </div>
          ))}
        </div>
      </section>

      <Discuss />
    </>
  );
}
